import React, { useState } from 'react';
import infographic from './mod.png';
import mobmod from './info-2.png';
import MainPopup from '../popup-containers/MainPopup';
import PopUpScreenTitle from '../components/PopUpScreenTitle';
import Assesementpopup from './Assesementpopup';
import icons10 from './icons10.png';

const Assessmentmodules = () => {
  const [Popup, setPopup] = useState(false);

  const openPopup = () => setPopup(true);
  const closePopup = () => setPopup(false);

  return (
    <section
      id="assessmentmodules"
      className="bg-white scroll-mt-20 text-black py-16 px-4 sm:px-6 lg:px-8 text-center relative lg:min-h-screen pb-12 flex flex-col justify-center"
    >
      <h2 className="text-3xl font-bold text-center mb-24">
        Assessment modules
      </h2>


      <div className="hidden [@media(min-width:1024px)]:block [@media(min-width:1280px)]:hidden">
        <div className="relative max-w-5xl mx-auto flex justify-center">
          <img
            src={/* Replace with your static image e.g. */ mobmod}
            alt="Assessment Modules Static Infographic"
            className="w-full max-w-4xl pb-6 mt-4"
          />
        </div>
      </div>

      {/* Mobile only */}
      <div className="block sm:hidden">
        <div className="relative max-w-7xl mx-auto flex justify-center">
          <img
            src={mobmod}
            alt="Mobile Assessment Modules Infographic"
            className="w-full max-w-xl pb-6 mt-4"
          />
        </div>
      </div>

      {/* Tablet only */}
      <div className="hidden sm:block lg:hidden">
        <div className="relative max-w-5xl mx-auto flex justify-center">
          <img
            src={mobmod}
            alt="Tablet Assessment Modules Infographic"
            className="w-full max-w-2xl pb-6 mt-4"
          />
        </div>
      </div>

      {/* Desktop only */}
      <div className="hidden xl:block mt-6 ">
        <div className="max-w-5xl mx-auto flex flex-col items-center justify-center ">
          {/* Heading */}

          {/* Image */}
          <div className="relative w-full flex justify-center">
            <img
              src={infographic}
              alt="Assessment Modules Infographic"
              className="w-full max-w-3xl pb-12 mt-4"
            />

            {/* Circle with icon */}
            <div className="absolute bottom-[10%] left-[47%] transform -translate-x-1/2 w-32 h-32 rounded-full bg-[#304755] flex items-center justify-center shadow-lg overflow-hidden">
              <img src={icons10} alt="General Icon" className="w-12 h-12 object-contain" />
            </div>
          </div>


          {/* General text attached to circle */}
          <div className="absolute bottom-[15%] left-[48%] transform -translate-x-1/2 w-56 text-center">
            <h3 className="font-bold">General</h3>
            <p className="text-sm ">
              Information of business, markets, statutory dues, customer complaints, etc.
            </p>
          </div>
        </div>

        {/* Other module labels */}
        <div className="absolute w-full h-full top-0 left-0 pointer-events-none">
          <div className="absolute right-[69%] top-[58%] transform -translate-x-1/2 w-48 text-left">
            <h3 className="font-bold">Environment</h3>
            <p className="text-sm">
              Evaluates environmental impact,<br />resource usage, and sustainability initiatives
            </p>
          </div>

          <div className="absolute right-[66%] top-[40%] transform -translate-y-3/4 w-48 text-left">
            <h3 className="font-bold">Procurement</h3>
            <p className="text-sm">
              Assesses sustainable sourcing practices and supplier management
            </p>
          </div>

          <div className="absolute bottom-[69%] left-[48%] transform -translate-x-1/2 -translate-y-1/2 w-48 h-20 text-center">
            <h3 className="font-bold">Ethics & Information Security</h3>
            <p className="text-sm">
              Reviews business ethics,<br />anti-corruption measures, and governance
            </p>
          </div>

          <div className="absolute left-[65%] bottom-[50%] transform -translate-y-1/2 w-48 text-right">
            <h3 className="font-bold">Labour & CSR</h3>
            <p className="text-sm">
              Examines labor practices, human rights, and community engagement
            </p>
          </div>

          <div className="absolute left-[69%] top-[65%] transform -translate-y-1/2 w-48 text-right">
            <h3 className="font-bold">Health & Safety</h3>
            <p className="text-sm">
              Evaluates workplace conditions and safety protocols
            </p>
          </div>
        </div>
      </div>

      {/* Popup Button */}
      <div className="text-center lg:mr-16 mt-16">
        <button
          className="bg-black mb-2 hover:bg-gray-800 text-white text-lg font-semibold py-2 px-5 rounded-md text-center"
          onClick={openPopup}
        >
          Alignment with Regulations and Reporting Frameworks
        </button>

        <MainPopup
          popUpOpen={Popup}
          setpopUpOpen={setPopup}
          bgcolor={true}
          loginPopups={true}
          widthAdjustment={true}
        >
          <PopUpScreenTitle
            title="Alignment with Regulations and Reporting Frameworks"
            setpopUpOpen={closePopup}
            hederDetails={true}
            titleColorstatus={true}
          />
          <Assesementpopup />
        </MainPopup>
      </div>
    </section>
  );
};

export default Assessmentmodules;
